// extracted by mini-css-extract-plugin
export default {"grid":"GridSection-module__grid--stTwq"};